import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { useCurrentAccount } from '@mysten/dapp-kit-react';
const AdminAddressContext = createContext({
    effectiveAddress: undefined,
    isAdminMode: false,
    adminAddress: undefined,
});
/**
 * Provides an "effective address" that is either an admin-specified address
 * from the URL `?address=0x...` param, or the connected wallet address.
 *
 * When `?address=` is present in the URL at page load, the app enters admin
 * mode: all portfolio data, holdings, and wallet-related UI reflect that
 * address rather than the currently connected wallet.
 */
export const AdminAddressProvider = ({ children }) => {
    const currentAccount = useCurrentAccount();
    // Read the address param once at mount — admin sets it directly in the URL.
    const [adminAddress] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('address') || undefined;
    });
    const isAdminMode = Boolean(adminAddress);
    const effectiveAddress = isAdminMode ? adminAddress : currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address;
    const contextValue = useMemo(() => ({ effectiveAddress, isAdminMode, adminAddress }), [effectiveAddress, isAdminMode, adminAddress]);
    return (_jsx(AdminAddressContext.Provider, { value: contextValue, children: children }));
};
export const useAdminAddress = () => useContext(AdminAddressContext);
